import { Amount, PercentAmount } from '@akropolis-web/primitives';

export function calculatePercentDeviation(
  observedValue: Amount,
  expectedValue: Amount,
): PercentAmount {
  return new PercentAmount(observedValue.sub(expectedValue).div(expectedValue).mul(100));
}
